import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path*',
        component: () => import('views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('views/login/login'),
    hidden: true
  },
  {
    path: '/404',
    component: () => import('views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('views/error-page/401'),
    hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('views/home/index'),
        name: '目录',
        meta: { title: '首页', icon: 'dashboard', affix: false }
      },
      // 路由参考样例 -- 点击跳转：全局搜索【更换组件】
      { 
        path: 'sysUser',
        component: () => import('views/sysUser'),
        name: '1111111',
        meta: { title: '2222222', icon: 'dashboard', affix: false }
      }
    ]
  }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js